import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { PopupAction } from '../../../../../common/popup/PopupAction'

import {
  applyCriteria,
  selectApplyingCriteria,
  selectCriteria,
} from '../../../selectCriteria/store/slice'
import { IGNORE_CHARACTER, MAX_INPUT_LENGTH } from '../../constant'
import { formatParamsGetResult } from '../../helper'
import { saveCriteria } from '../../store/thunk'
import {
  changeSaveCriteriaPopup,
  selectSaveCriteriaPopup,
  selectScreeningIndicatorById,
} from './../../store/slice'
import { OpenRecentSavedPopup } from './OpenRecentSaved'
import { SaveAs } from './SaveAs'
import { SaveFormOption } from './SaveFormOption'

export const SaveCriteriaPopup = () => {
  const dispatch = useDispatch()
  const requiredNameMessage = UseI18n('screening.CRITERIA_NAME_REQUIRED_MESS')

  const { isShow, lastPathname } = useSelector(selectSaveCriteriaPopup)
  const criteria = useSelector(selectCriteria())
  const applyingCriteria = useSelector(selectApplyingCriteria())
  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())

  const [isSaveAs, setIsSaveAs] = useState(false)
  const [name, setName] = useState('')
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showRecentSavedCriteriaPopup, setShowRecentSavedCriteriaPopup] =
    useState(false)
  const [savedCriteriaId, setSavedCriteriaId] = useState()

  const handleClose = (clearLastPathname = true) => {
    if (isLoading) return

    setName('')
    setIsSaveAs(false)
    setError(null)
    dispatch(
      changeSaveCriteriaPopup({
        isShow: false,
        lastPathname: clearLastPathname ? null : lastPathname,
      }),
    )
  }

  const handleChangeName = (value) => {
    setName(
      value
        .slice(0, MAX_INPUT_LENGTH)
        .split('')
        .filter((c) => !IGNORE_CHARACTER.includes(c))
        .join(''),
    )
    setError(null)
  }

  const getIsValidForm = () => {
    if (isSaveAs || !applyingCriteria) {
      if (!name) {
        setError(requiredNameMessage)
        return false
      }
      if (error) return false
    }

    return true
  }

  const handleSave = () => {
    if (!getIsValidForm() || isLoading) return

    const params = {
      name:
        isSaveAs || !applyingCriteria
          ? name
          : applyingCriteria.screeningSavedCriteriaName,
      parameters: criteria,
      screeningCriteria: formatParamsGetResult({
        criteria,
        screeningIndicatorById,
      }),
    }

    if (applyingCriteria && !isSaveAs) {
      params.id = applyingCriteria.id
    }

    setIsLoading(true)

    dispatch(saveCriteria(params))
      .unwrap()
      .then((criteriaId) => {
        setSavedCriteriaId(criteriaId)
        setIsLoading(false)
        handleClose(false)
        setShowRecentSavedCriteriaPopup(true)
        dispatch(
          applyCriteria({
            id: criteriaId,
            screeningSavedCriteriaName: params.name,
            parameters: params.parameters,
          }),
        )
      })
      .catch((error) => {
        setIsLoading(false)
        setError(error)
      })
  }

  return (
    <>
      <PopupAction
        isShow={isShow}
        title="screening.SAVE_CRITERIA"
        btnCancel={{
          label: 'screening.CANCEL',
          isI18n: true,
          event: handleClose,
          disabled: isLoading,
        }}
        btnSubmit={{
          label: 'screening.SAVE',
          isI18n: true,
          event: handleSave,
          disabled: (isSaveAs || !applyingCriteria) && !name.trim().length,
        }}
        handleClose={handleClose}
      >
        {applyingCriteria ? (
          <SaveFormOption
            isSaveAs={isSaveAs}
            setIsSaveAs={setIsSaveAs}
            name={name}
            handleChangeName={handleChangeName}
            applyingCriteriaName={applyingCriteria.screeningSavedCriteriaName}
            error={error}
            isLoading={isLoading}
          />
        ) : (
          <SaveAs
            name={name}
            handleChangeName={handleChangeName}
            error={error}
            disabled={isLoading}
          />
        )}
      </PopupAction>
      <OpenRecentSavedPopup
        isShow={showRecentSavedCriteriaPopup}
        setIsShow={setShowRecentSavedCriteriaPopup}
        savedCriteriaId={savedCriteriaId}
      />
    </>
  )
}
